module.exports = __webpack_public_path__ + "static/media/icon_washer.700fd4f3.svg";